<section class="!overflow-hidden !rounded-2xl !border !border-dashed !border-slate-300 !bg-slate-50 !p-6 md:!p-8"
         aria-labelledby="settings-debug-title">
    <div class="!mb-5 !flex !flex-wrap !items-start !justify-between !gap-3 !border-b !border-solid !border-slate-200 !pb-3">
        <div>
            <p class="!mb-1 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">Superadmin</p>
            <h3 id="settings-debug-title" class="!mb-1 !text-base !font-bold !text-strong">Dati di debug</h3>
            <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                Identificativi e valori grezzi utili in assistenza. Non visibili agli altri ruoli.
            </p>
        </div>
        <button type="button"
                class="!m-0 !rounded-lg !border !border-solid !border-slate-200 !bg-white !px-3 !py-2 !text-xs !font-semibold !text-slate-600 hover:!bg-slate-100"
                (click)="expanded = !expanded">
            {{ expanded ? 'Nascondi JSON' : 'Mostra JSON grezzo' }}
        </button>
    </div>

    <div class="!flex !flex-col">
        <div class="!grid !grid-cols-1 !items-start !gap-2 !border-0 !border-b !border-solid !border-slate-200 !py-3 last:!border-b-0 sm:!grid-cols-[12rem_minmax(0,1fr)_auto] sm:!gap-4"
             *ngFor="let row of rows">
            <span class="!text-[11px] !font-bold !uppercase !tracking-wide !text-slate-400">{{ row.label }}</span>
            <span class="!break-all !font-mono !text-sm !text-slate-800">{{ row.value }}</span>
            <button type="button"
                    *ngIf="row.value && row.value !== '—'"
                    class="!m-0 !inline-flex !h-7 !w-7 !items-center !justify-center !rounded-md !border-0 !bg-transparent !p-0 !text-slate-400 hover:!bg-white hover:!text-slate-700"
                    (click)="copy(row.value)"
                    [attr.aria-label]="'Copia ' + row.label">
                <i class="bi bi-clipboard" aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <pre class="!mb-0 !mt-4 !max-h-80 !overflow-auto !rounded-xl !bg-slate-900 !p-4 !text-xs !leading-relaxed !text-slate-100"
         *ngIf="expanded && extraRawJson">{{ extraRawJson }}</pre>
</section>
